import { initializeApp } from "firebase/app";
import { persistentLocalCache, initializeFirestore } from "firebase/firestore";
import Constants from "expo-constants";

const firebaseConfig = Constants.expoConfig?.extra?.firebase;

if (!firebaseConfig?.apiKey || !firebaseConfig?.projectId) {
  const appEnv = Constants.expoConfig?.extra?.appEnv || "unknown";
  throw new Error(
    `Invalid Firebase configuration (appEnv: ${appEnv}). apiKey and projectId are required. ` +
      "Ensure EXPO_PUBLIC_FIREBASE_API_KEY and EXPO_PUBLIC_FIREBASE_PROJECT_ID " +
      "are set in your .env (dev) or .env.production (prod) file.",
  );
}

const firebaseApp = initializeApp(firebaseConfig);

initializeFirestore(firebaseApp, { localCache: persistentLocalCache({}) });

export { firebaseApp };
